import request from '@/utils/request'
let baseURL = '/publish-api';

//根据条件查询所有文章（App分页）
export function getAppEssaysByCondition(data) {
  return request({
    url: '/essay/v1/getAppEssaysByCondition',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
auditStatus (string, optional): 文章审核状态：DRAFT-草稿；AUDIT-提交审核；AUDIT_OK-审核通过；AUDIT_NG-审核不通过 ,
categoryId (integer, optional): 文章末级分类ID ,
createTime1 (string, optional): 发布时间1 ,
createTime2 (string, optional): 发布时间2 ,
essayNo (integer, optional): 文章编号 ,
nickname (string, optional): 文章发布人的昵称 ,
page (integer, optional),
shelvesStatus (string, optional): 文章上架状态，ON_SHELF-上架；OFF_SHELF-主动下架；FORCE_OFF_SHELF-强制下架 ,
size (integer, optional),
type (integer, optional): 文章类型，0：云柑号文章，1：H5文章
}
* */


// 根据文章编号获取详细内容
export function getEssayByNo(data) {
  return request({
    url: '/essay/v1/getEssayByNo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
essayNo (integer): 文章编号
}
* */

// 获取文章内容(mongodb)
export function getEssayContent(data) {
  return request({
    url: '/essay/v1/getEssayContent',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
essayNo (integer): 文章编号
}
* */

// 点赞或取消点赞
export function doPraise(data) {
  return request({
    url: '/praise/v1/doPraise',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
essayNo (integer): 文章编号 ,
userOpenid (string): 用户openid
}
* */

// 收藏或取消收藏
export function doCollect(data) {
  return request({
    url: '/collect/v1/doCollect',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
essayNo (integer): 文章编号 ,
userOpenid (string): 用户openid
}
* */

